import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';
import { StandardModifierService } from './service';

@inject(StandardModifierService, DialogService, EventAggregator)
export class StandardModifiers {
    constructor(standardModifierService, dialogService, ea) {
        this.ea = ea;
        this.standardModifierService = standardModifierService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'identifier', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'identifierName' },
            { dataField: 'workCenter' },
            { dataField: 'processName' },
            { dataField: 'operation' },
            { dataField: 'value' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('standard-modifiers:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (standardModifier) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.standardModifierService.delete(standardModifier.id);
                this.grid.refresh();
                toastr.success('Standard modifier was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.standardModifierService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.standardModifierService.editor, model: { id: data.id } });
    };
}